import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Button, Stack, HeaderText, BodyText,
} from '../../../../../ui';
import Image from '../../../../../shared/Image';
import { DismissButton } from './DismissButton';
import TimeToComplete from './TimeToComplete';

import { InsightCardProps } from '../types';

export const BASE_ID = 'marketing-tips-marquee-card';
const CopyCtaLeftImageRight: React.FC<InsightCardProps> = ({
  id,
  cta,
  clickThroughData,
  analyticsData,
  onClick,
  onAction,
  firstViewTracking,
  metadata = {},
  image,
  headline,
  bodyText = [{}],
  timeToComplete,
  dismissParams,
}) => {
  const instanceId = `${BASE_ID}-${id}`;
  const [hasTracked, setHasTracked] = useState(false);
  const {
    headlineProps,
    imageProps,
  } = metadata;
  const [headlineRenderProps] = useState(headlineProps || {});
  const [imageRenderProps] = useState(imageProps || {});
  const { text, color: textColor } = bodyText[0];

  const visibilityChangeHandler = isVisible => {
    if (hasTracked) {
      return;
    }

    if (isVisible && firstViewTracking) {
      setHasTracked(true);
      firstViewTracking?.();
    }
  };

  return (
    <VisibilitySensor onChange={visibilityChangeHandler}>
      <Box
        padding={4}
        testID={instanceId}
        overflow="hidden"
      >
        <Inline
          alignItems="center"
          showBoxShadow
          color={colors.whiteWash}
          minHeight={260}
          justifyContent="space-evenly"
        >
          <Stack
            maxWidth={206}
            paddingX={24}
            justifyContent="center"
            space={text ? 8 : 20}
          >
            <Inline paddingBottom={text ? 8 : 16}>
              <TimeToComplete
                testId={`${instanceId}-time-to-complete`}
                time={timeToComplete}
              />
            </Inline>
            <HeaderText
              color={colors.blackInBlack}
              {...headlineRenderProps}
            >
              {headline}
            </HeaderText>
            {text && (
              <BodyText color={textColor} appearance="medium">{text}</BodyText>
            )}
            <Inline>
              <Button
                size="small"
                onClick={() => onClick(clickThroughData, analyticsData, onAction)}
                testID={`${instanceId}-cta`}
              >
                {cta}
              </Button>
            </Inline>
            {dismissParams && (
              <Inline>
                <DismissButton {...dismissParams} />
              </Inline>
            )}
          </Stack>
          <Box
            color={colors.lightChill}
            minWidth={129}
            alignItems="center"
            justifyContent="center"
          >
            <Image source={image} resizeMode="cover" style={{ ...imageRenderProps }} />
          </Box>
        </Inline>
      </Box>
    </VisibilitySensor>
  );
};

export default CopyCtaLeftImageRight;
